// Determine challenge window size based on screen width (matching backend logic)
export const getChallengeSize = (screenWidth: number) => {
  if (screenWidth >= 600) {
    // 600x400
    return 'lg';
  }

  if (screenWidth >= 500) {
    // 500x600
    return 'md';
  }

  if (screenWidth >= 390) {
    // 390x400
    return 'sm';
  }

  // Default to smallest
  return 'xs';
};
